import React from 'react';
import styled, { css } from 'styled-components';

import { Icon } from 'common';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  ${({ theme }) => css`
    gap: ${theme.padding.smallest};
    padding: ${theme.padding.small};
    background-color: ${theme.colors.grey.main};
    border-radius: ${theme.borderRadius.biggest};

    .header-container {
      .open-book-icon {
        path {
          stroke: ${theme.colors.lightGrey.main};
        }
      }

      display: flex;
      flex-direction: row;
      gap: ${theme.padding.smallest};

      h3 {
        color: ${theme.colors.lightGrey.main};
      }
    }
  `}
`;

interface Props {
  label: string;
  icon?: string;
  children?: string;
}

export const Note = ({ icon, label, children }: Props) => {
  return (
    <Container>
      <div className="header-container">
        {icon && <Icon icon={icon} />}
        <h3>{label}</h3>
      </div>

      <p>{children ?? '-/-'}</p>
    </Container>
  );
};
